import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { UserConnectionResponse } from '../../types/Types';

interface useGetConnectionsProps {
  userId: string;
  enabled?: boolean;
}

export function useGetConnections({ userId, enabled = true }: useGetConnectionsProps) {
  return useQuery({
    enabled,
    queryKey: ['userconnections', userId],
    queryFn: async () => {
      return axiosInstance<UserConnectionResponse>(getAPIURL(`/User/userconnections/${userId}/`)).then(
        (response) => response.data,
      );
    },
  });
}